import { DEFAULT_FREE_TEXT_DELIMITER } from '@pm/forms';
import { QuestionnaireRadioQuestion } from '@pm/graphql';
import { REQUIRED_MESSAGE, STRING_REQUIRED_SCHEMA } from './sharedSchemas';

// Empty free-text submission is just the trimmed delimiter
const EMPTY_FREE_TEXT_VALUE = DEFAULT_FREE_TEXT_DELIMITER.trim();

export const radioQuestionSchema = ({
  acceptableAnswers,
}: QuestionnaireRadioQuestion) => {
  const hasFreeText = acceptableAnswers?.some(
    (answer) => answer.value === null,
  );

  if (!hasFreeText) {
    return STRING_REQUIRED_SCHEMA;
  }

  return STRING_REQUIRED_SCHEMA.test(
    'non-empty-free-text',
    REQUIRED_MESSAGE,
    (value) => value?.trim() !== EMPTY_FREE_TEXT_VALUE,
  );
};
